import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import ModalWithConfirmation from 'components/ModalWithConfirmation';
import { CREATE_SPRAY_EVENT_MODAL } from '../../constants';
import SprayEventFinalForm from '../SprayEventFinalForm';

interface ConnectedProps {
    isOpen?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

export type Props = ConnectedProps & DispatchProps;

export class CreateSprayEventModalComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            [CREATE_SPRAY_EVENT_MODAL]: undefined
        });
    };

    render(): React.ReactElement {
        const { isOpen } = this.props;

        return (
            <CurrentSeasonInProgressGate>
                <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                    <ModalWithConfirmation
                        size="fullscreen"
                        open={isOpen}
                        centered={false}
                        onCloseClick={this.handleClose}
                        closeIcon
                        className="spray-event-modal"
                        showConfirmation
                    >
                        <ErrorBoundary
                            namespace="sprayEventCreateModal"
                            FallbackComponent={<ErrorBoundaryAlert />}
                        >
                            <SprayEventFinalForm title="New Spray Schedule" />
                        </ErrorBoundary>
                    </ModalWithConfirmation>
                </RoleGate>
            </CurrentSeasonInProgressGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, any, ConnectedProps>(
    {
        isOpen: makeSelectQueryStringBooleanValue(CREATE_SPRAY_EVENT_MODAL)
    }
);

export default connect(mapStateToProps, {
    updateQueryString
})(CreateSprayEventModalComponent);
